import {getApi} from '../../modules/common/utils/api'

const api = getApi('default')

export function getSettings() {
  return api.get(`/v3/settings`)
}
